<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100" v-if="$constants.userCan(['report.getreport'])">
      <div class="md-layout">
        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <md-icon>₦</md-icon>
              </div>
              <p class="category">Daily Volume</p>
              <h3 class="title" v-if="dailyTotal">
                &#8358;
                <strong>{{$numeral(dailyTotal).format('0,0.00')}}</strong>

              </h3>
              <md-progress-spinner
                class="md-accent"
                :md-stroke="3"
                :md-diameter="20"
                md-mode="indeterminate"
                v-else
              ></md-progress-spinner>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <md-icon>₦</md-icon>
              </div>
              <p class="category">Monthly Volume</p>
              <h3 class="title" v-if="monthlyTotal">
                &#8358;
                <strong>{{$numeral(monthlyTotal).format('0,0.00')}}</strong>
              </h3>
              <md-progress-spinner
                class="md-accent"
                :md-stroke="3"
                :md-diameter="20"
                md-mode="indeterminate"
                v-else
              ></md-progress-spinner>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <md-icon>₦</md-icon>
              </div>
              <p class="category">Annual Volume</p>
              <h3 class="title" v-if="annualTotal">
                &#8358;
                <strong>{{$numeral(annualTotal).format('0,0.00')}}</strong>
              </h3>
              <md-progress-spinner
                class="md-accent"
                :md-stroke="3"
                :md-diameter="20"
                md-mode="indeterminate"
                v-else
              ></md-progress-spinner>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>published_with_changes</md-icon>
              </div>
              <p class="category">Daily Count</p>
              <h3 class="title" v-if="dailyCount">
                {{$numeral(dailyCount).format('0,0')}}
              </h3>
              <md-progress-spinner
                class="md-accent"
                :md-stroke="3"
                :md-diameter="20"
                md-mode="indeterminate"
                v-else
              ></md-progress-spinner>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>published_with_changes</md-icon>
              </div>
              <p class="category">Monthly Count</p>
              <h3 class="title" v-if="monthlyCount">
                {{$numeral(monthlyCount).format('0,0')}}
              </h3>
              <md-progress-spinner
                class="md-accent"
                :md-stroke="3"
                :md-diameter="20"
                md-mode="indeterminate"
                v-else
              ></md-progress-spinner>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>published_with_changes</md-icon>
              </div>
              <p class="category">Annual Count</p>
              <h3 class="title" v-if="annualCount">
                {{$numeral(annualCount).format('0,0')}}
              </h3>
              <md-progress-spinner
                class="md-accent"
                :md-stroke="3"
                :md-diameter="20"
                md-mode="indeterminate"
                v-else
              ></md-progress-spinner>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <md-icon>₦</md-icon>
              </div>
              <p class="category">Total Revenue(This Year)</p>
              <h3 class="title">
                &#8358;
                <strong>{{$numeral(totalRevenue).format('0,0.00')}}</strong>
              </h3>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <md-icon>account_balance</md-icon>
              </div>
              <p class="category">Total Number of individual Tax Payers</p>
              <h3 class="title">
                <strong>{{$numeral(stats.TotalPayer).format('0,0')}}</strong>
                <!--<animated-number :value="$numeral(monthlyFigure).format('0,0')"></animated-number>-->
              </h3>
            </template>

            <!--<template slot="footer">-->
            <!--<div class="stats">-->
            <!--<md-icon class="text-danger">warning</md-icon>-->
            <!--<a href="#pablo">Get More Space...</a>-->
            <!--</div>-->
            <!--</template>-->
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <md-icon>account_balance</md-icon>
              </div>
              <p class="category">Total number of Individual Tax Payers employed</p>
              <h3 class="title">
                <strong>{{$numeral(stats.TotalCorporate).format('0,0')}}</strong>
                <!--<animated-number :value="$numeral(monthlyFigure).format('0,0')"></animated-number>-->
              </h3>
            </template>

            <!--<template slot="footer">-->
            <!--<div class="stats">-->
            <!--<md-icon class="text-danger">warning</md-icon>-->
            <!--<a href="#pablo">Get More Space...</a>-->
            <!--</div>-->
            <!--</template>-->
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="warning">
            <template slot="header">
              <div class="card-icon">
                <md-icon>account_balance</md-icon>
              </div>
              <p class="category">Total number of self- employed Individual Tax Payers</p>
              <h3 class="title">
                <strong>{{$numeral(stats.TotalDirAsstPayer).format('0,0')}}</strong>
                <!--<animated-number :value="1840000"></animated-number>-->
              </h3>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>people</md-icon>
              </div>
              <p class="category">Total number of Individual Tax Payers with BVN</p>
              <h3 class="title">{{$numeral(stats.TotalBvnPayer).format('0,0')}}</h3>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>business</md-icon>
              </div>
              <p class="category">Total number of Individual Tax Payers employed with BVN</p>
              <h3 class="title">{{$numeral(stats.CorporatePayerBVN).format('0,0')}}</h3>
            </template>
          </stats-card>
        </div>

        <div class="md-layout-item md-xsmall-size-100 md-size-33">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>people_outline</md-icon>
              </div>
              <p class="category">Total number of self- employed Individual Tax Payers with BVN</p>
              <h3 class="title">{{$numeral(stats.DirAsstPayerBVN).format('0,0')}}</h3>
            </template>
          </stats-card>
        </div>
      </div>
    </div>

    <md-card v-else class="md-layout-item md-size-100">
      <md-card-content>
        <h4 style="text-align: center">Welcome to the Easy Tax Admin Portal</h4>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { StatsCard } from "@/components";

export default {
  components: {
    StatsCard
  },

  data() {
    return {
      regions: [],
      officeRegion: "all",
      stats: {},
      annualTotal: 0,
      dailyTotal: 0,
      monthlyTotal: 0,
      annualCount: 0,
      dailyCount: 0,
      monthlyCount: 0,
      totalRevenue: 0,
    };
  },

  methods: {
    getStats() {
      this.$http.post("abc/tax/payers/stats", { method: "GET" }).then(
        response => {
          if (response.data) {
            if (response.data.error) {
              this._handleErrors(response.data);
            } else {
              this.stats = response.data;
            }
          } else {
            this.notification("An Unknown Error Occurred", "error", "danger");
          }
        },
        error => {
          this.notification(error.message, "error", "danger");
        }
      );
    },

    getDailyVolume() {
      const apiUrl = "abc/collections/daily";
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            params: {
              skipLoader: true
            }
          }
        )
        .then(
          response => {
            if (response.data) {
              if (response.data.error) {
                this._handleErrors(response.data);
              } else {
                const { data } = response;

                this.dailyTotal = data.DailyTotal;
                this.monthlyTotal = data.MonthTotal;
                this.annualTotal = data.AnnualTotal;
                this.dailyCount = data.DailyCount;
                this.monthlyCount = data.MonthCount;
                this.annualCount = data.AnnualCount;
              }
            } else {
              this.notification("An Unknown Error Occurred", "error", "danger");
            }
          },
          error => {
            this.notification(error.message, "error", "danger");
          }
        );
    },

    getRevenue() {
      const start = this.$moment().startOf("year").format("YYYY-MM-DD");
      const end = this.$moment().format("YYYY-MM-DD");

      this.$http.post("abc/revenue/stats", { method: "GET", params: `&start_date=${start}&end_date=${end}`}).then(
        response => {
          if (response.data) {
            this.totalRevenue = response.data.TotalAmountPaid;
          }
        }
      );
    },

    _handleErrors(response) {
      if (response.data) {
        for (let message in response.data) {
          this.notification(response.data[message][0], "pan_tool", "danger");
        }
      } else {
        if(response.code !== 'ACCESS_DENIED') {
          this.notification(response.message, "pan_tool", "danger");
        }
      }
    },
    notification(message, icon, color) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: color
      });
    }
  },
  mounted() {
    this.getStats();
    this.getDailyVolume();
    this.getRevenue();
  }
};
</script>
